<script setup lang="ts">
import { useQuery } from "@tanstack/vue-query";

const { $trpc } = useNuxtApp();
const { data: paychecks } = useQuery({
  queryKey: ["listPaychecks"],
  queryFn: () => $trpc.listPaychecks.query(),
});

const paycheck = computed(() => {
  if (!paychecks.value) return null;
  const entries = Object.entries(paychecks.value);
  if (entries.length === 0) return null;

  return entries[0][1];
});
</script>

<template>
  <PaycheckModal v-if="paycheck" :paycheck="paycheck" />
  <!-- <PaydayModal
    v-if="paycheck && paycheck.campaign.apyBonus"
    :paycheck="paycheck"
  /> -->
</template>
